import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, Link, useSearchParams } from 'react-router-dom';
import ScreenHeader from '../components/ScreenHeader';
import useSWR from 'swr';
import { localAxios } from "../api";
import { workflowStatePath } from "../utils/siteMap";

function Login(props) {

    const { data, error, isLoading, mutate } = useSWR('/api/me', localAxios);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loginError, setLoginError] = useState('');

    useEffect(() => {
        const inviteToken = searchParams.get('invite_token');
        if (inviteToken) {
            navigate(`/register?invite_token=${inviteToken}`);
        }
    }, []);

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        const form = event.target;
        let formData = new FormData(form);
        const todayDate = new Date();
        formData.append("todayDate", todayDate.toISOString());

        let formDataObj = Object.fromEntries(formData.entries());
        let formJSON = JSON.stringify(formDataObj);

        setLoginError('');
        try {
            const response = await localAxios.post('/login', formJSON);
            if (response) {
                const inviteToken = searchParams.get('invite_token');
                if (inviteToken) {
                    try {
                        await localAxios.post('/api/invite/accept', JSON.stringify({ token: inviteToken }));
                    } catch (err) {
                        console.log('Error accepting invitation:', err);
                    }
                }
                mutate();
            }
        } catch (err) {
            const status = err?.response?.status;
            if (status === 400) {
                setLoginError('Please enter your email and password.');
            } else if (status === 401) {
                setLoginError('Email address not found or password is incorrect. Please try again.');
            } else {
                setLoginError('Something went wrong. Please try again.');
            }
        }
    };

    if (data?.data.loggedIn) {
        const redirectPath = localStorage.getItem("redirectPath");
        if (redirectPath) {
            localStorage.removeItem("redirectPath");
            return <Navigate to={redirectPath} />;
        }

        const resumePath = workflowStatePath(data.data.workflow_state);
        return <Navigate to={resumePath || "/"} />;
    }

    return (
        <div className="app-wide__container">
            <ScreenHeader message="Visitor Training Tracker" />

            <div className="app-wide__add-new login__heading">
                <h2 className="login__title">Please Log In</h2>
            </div>

            <div className="app-wide__main login__main">
                <form id="loginForm" onSubmit={handleFormSubmit} className="login__form">
                    <div className="login__field">
                        <label className="login__label" htmlFor="userEmail">Email</label>
                        <input
                            id="userEmail"
                            className="login__input"
                            type="text"
                            autoCapitalize="off"
                            name="userEmail"
                        />
                    </div>
                    <div className="login__field">
                        <label className="login__label" htmlFor="password">Password</label>
                        <input
                            id="password"
                            className="login__input"
                            type="password"
                            name="password"
                        />
                    </div>
                    <p className="login__register-link">
                        Need an account?{' '}
                        <Link to={searchParams.get('invite_token') ? `/register?invite_token=${searchParams.get('invite_token')}` : '/register'}>
                            Register here
                        </Link>
                    </p>
                    {loginError && (
                        <p className="login__error">{loginError}</p>
                    )}
                </form>
            </div>

            <div className="app-wide__footer login__footer">
                <button type="submit" form="loginForm" className="login__submit-btn">
                    Log In
                </button>
            </div>
        </div>
    );
}

export default Login;
